import { render, staticRenderFns } from "./QuotationsPublicView.vue?vue&type=template&id=465214a5&scoped=true&"
import script from "./QuotationsPublicView.vue?vue&type=script&lang=js&"
export * from "./QuotationsPublicView.vue?vue&type=script&lang=js&"
import style0 from "./QuotationsPublicView.vue?vue&type=style&index=0&id=465214a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465214a5",
  null
  
)

export default component.exports